<template>
  <div class="main-container">
    <div class="admin-info">
      <h3>Ваш профіль</h3>
      <label class="mt-2">Пошта : </label>
      <b-form-input
        class="info-inputs mt-2"
        v-model="admin[0].email"
        trim
        readonly
      ></b-form-input>
      <label class="mt-2">Ім'я : </label>
      <b-form-input
        class="info-inputs mt-2"
        v-model="admin[0].name"
        trim
        readonly
      ></b-form-input>
      <label class="mt-2">Призвіще : </label>
      <b-form-input
        class="info-inputs mt-2"
        v-model="admin[0].surname"
        trim
        readonly
      ></b-form-input>
      <label class="mt-2">Номер телефону : </label>
      <b-form-input
        class="info-inputs mt-2"
        v-model="admin[0].phonenum"
        trim
        readonly
      ></b-form-input>
      <b-button id="patchbtn" class="patchbtn mt-2" v-on:click="patchUser()"
        >Редагувати</b-button
      >
      <hr />
      <br />
      <h2>Смена паролю</h2>
      <b-form-group
        label="Новий пароль"
        label-for="name-input"
        invalid-feedback="Пароль має містити не меньше ніж 8 знаків!"
      >
        <b-form-input
          @blur="$v.new_pass.$touch()"
          :class="{ 'is-invalid': $v.new_pass.$error && $v.new_pass.$dirty }"
          class="info-inputs mt-2"
          v-model="new_pass"
          trim
          readonly
        ></b-form-input>
      </b-form-group>
      <b-form-group
        label="Підтвердження паролю"
        label-for="name-input"
        invalid-feedback="Паролі не співпадають!"
      >
        <b-form-input
          @blur="$v.passConfirm.$touch()"
          :class="{
            'is-invalid': $v.passConfirm.$error && $v.passConfirm.$dirty,
          }"
          class="info-inputs mt-2"
          v-model="passConfirm"
          trim
          readonly
        ></b-form-input>
      </b-form-group>

      <!--    <div v-if="this.$cookie.get('role') !== 'superadmin'">-->
      <!--      <div>Очки заданий : </div>-->
      <!--      <b-form-input class="info-inputs" v-model="admin[0].task_points" trim readonly></b-form-input>-->
      <!--    </div>-->
    </div>
    <div class="admin-list">
      <admin-list v-if="user.role == 'superadmin'" />
    </div>
    <Alert
      :class="this.class"
      v-bind:text="this.AlertText"
      v-bind:activErr="this.activErr"
    ></Alert>
  </div>
</template>

<script>
import AdminList from "@/components/lists/AdminList";
import Alert from "@/components/Toasts/Alert";
import { mapState } from "vuex";
import axios from "axios";
import { minLength, sameAs } from "vuelidate/lib/validators";
export default {
  name: "AdminInfo",
  components: {
    AdminList,
    Alert,
  },
  data: function () {
    return {
      admin: {},
      el_state: false,
      activErr: false,
      AlertText: null,
      class: null,
      new_pass: null,
      passConfirm: null,
    };
  },
  validations: {
    new_pass: {
      minLength: minLength(8),
      valid: function (value) {
        const containsNumber = /[0-9]/.test(value);
        return containsNumber;
      },
    },
    passConfirm: {
      sameAs: sameAs("new_pass"),
    },
  },
  computed: {
    ...mapState(["user"]),
  },
  mounted() {
    this.admin = this.user;
  },
  methods: {
    userPatch() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      let payload = {
        email: this.admin[0].email,
        name: this.admin[0].name,
        surname: this.admin[0].surname,
        phonenum: this.admin[0].phonenum,
        birthday: this.admin[0].birthday,
        new_pass: this.new_pass,
      };
      let config = {
        headers: {
          Authorization: `Bearer ${this.$cookie.get("access_token")}`,
        },
      };
      axios
        .put(`${process.env.VUE_APP_API}/admin/patch`, payload, config)
        .then((response) => {
          console.log(response.data);
          this.showModalCreate("інформація успешно оновлена!", "green");
          this.new_pass = null;
          this.passConfirm = null;
          this.$v.$reset();
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.logOutUser();
          } else {
            this.showModalCreate("Щось пішло не так!", "red");
            window.location.reload();
          }
        });
    },
    showModalCreate(text, color) {
      this.activErr = true;
      this.class = color;
      this.AlertText = text;
      setTimeout(() => {
        this.activErr = false;
      }, 4000);
    },
    patchUser() {
      let els = document.getElementsByClassName("info-inputs");
      if (this.el_state === false) {
        els.forEach((ele) => {
          ele.removeAttribute("readonly");
        });
        this.$v.$reset();
        this.el_state = true;
      } else {
        els.forEach((ele) => {
          ele.setAttribute("readonly", true);
        });
        this.el_state = false;
        this.userPatch();
      }
    },
  },
};
</script>

<style scoped>
.main-container {
  display: flex;
  flex-direction: row;
}
.admin-info {
  display: block;
  width: 30%;
  margin: auto;
}
/*.admin-list {*/
/*  display: block;*/
/*  width: 30%;*/
/*  margin-left: auto;*/
/*  margin-right: auto;*/
/*}*/
/*.patchbtn {*/
/*  margin-top: 10px;*/
/*  margin-bottom: 10px;*/
/*}*/
</style>
